import * as React from 'react';

const PaletteColorIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path d="M15.999 8.5a.362.362 0 0 0-.364.367.366.366 0 1 0 .364-.367ZM9.232 15.999a.366.366 0 1 0-.731.005.366.366 0 0 0 .731-.005ZM21.303 10.696a.366.366 0 1 0-.514.52.366.366 0 0 0 .514-.52ZM11.213 20.785a.366.366 0 1 0-.513.52.366.366 0 0 0 .513-.52ZM11.216 11.213a.366.366 0 1 0-.52-.513.366.366 0 0 0 .52.513Z" />
      <path d="M16 28C9.26 28 3.816 22.442 4.004 15.66 4.178 9.399 9.398 4.179 15.659 4.005 22.442 3.817 28 9.26 28 16v1.333A2.666 2.666 0 0 1 25.333 20h-2.75a2.666 2.666 0 0 0-2.565 3.398l.343 1.202a2.666 2.666 0 0 1-2.563 3.4H16Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default PaletteColorIcon;
